import {MultiSelectRowHeader} from "./MultiSelectRowHeader";
import React, {useContext, useState} from "react";
import {ListItemText, MenuItem} from "@mui/material";
import {MoveSelectedOpenings} from "./MoveSelectedOpenings";
import {BulkOpeningEditor} from "./logictrl/BulkOpeningEditor";
import {SetByOthers, applyByOthers} from "./SetByOthers";
import {api} from "../../../../api/API";
import {Opening} from "../../../../api/Openings";
import {EditContext} from "../../../../misc/scroller/EditProvider";
import {useSnackAction} from "../hardware/SnackAction";
import {useProjectId} from "../ProjectName";

export function OpeningBulkActions() {

    const edit = useContext(EditContext);
    const project = useProjectId();

    const [move, setMove] = useState<{
        ids: number[];
        reset: () => void;
    }|null>(null)

    const [bulkLogistics, setBulkLogistics] = useState<{
        ids: number[];
        reset: () => void;
    }|null>(null)

    const [byOthers, setByOthers] = useState<{
        ids: number[];
        reset: () => void;
    }|null>(null)

    const recalculate = useSnackAction(async (input: {openings: number[]; reset: () => void}) => {
        await api.openings.recalculate({project: project, openings: input.openings});
        await edit.reload();
        input.reset();
    }, {
        success: "Recalculated",
    });

    return (
        <>
            <MultiSelectRowHeader>
                {(close, ids, reset) => {
                    return (
                        <>
                            <MenuItem onClick={async () => {
                                close();
                                setMove({
                                    ids: ids,
                                    reset: reset,
                                })
                            }}>
                                <ListItemText>Move Selected</ListItemText>
                            </MenuItem>
                            <MenuItem onClick={async () => {
                                close();
                                setBulkLogistics({
                                    ids: ids,
                                    reset: reset,
                                })
                            }}>
                                <ListItemText>Bulk Logistics</ListItemText>
                            </MenuItem>
                            <MenuItem onClick={async () => {
                                close();
                                setByOthers({
                                    ids: ids,
                                    reset: reset,
                                })
                            }}>
                                <ListItemText>Set By-Us</ListItemText>
                            </MenuItem>
                            <MenuItem disabled={recalculate.loading} onClick={() => {
                                close();
                                recalculate.callback({openings: ids, reset: reset});
                            }}>
                                <ListItemText>Recalculate Selected</ListItemText>
                            </MenuItem>
                        </>
                    )
                }}
            </MultiSelectRowHeader>
            {byOthers && <SetByOthers
                onCancel={() => setByOthers(null)}
                onSubmit={async (input) => {
                    const all = edit.dataRef.current.flatMap(d => d.rows) as Opening[];
                    const updated = all
                        .filter(o => byOthers.ids.includes(o.id))
                        .map(o => ({
                            ...o,
                            doorActiveByOthers: applyByOthers(input.door, o.doorActiveByOthers),
                            doorInactiveByOthers: applyByOthers(input.door, o.doorInactiveByOthers),
                            frameByOthers: applyByOthers(input.frame, o.frameByOthers),
                        }));

                    await api.openings.bulkUpsert(updated);
                    await edit.reload();
                    const current = byOthers;
                    setByOthers(null);
                    current.reset();
                }} />}
            {move && <MoveSelectedOpenings
                ids={move.ids}
                onCancel={() => setMove(null)}
                onDone={() => {
                   setMove(null);

                   if(!move) return;
                   move.reset();
                }} />}
            {bulkLogistics && <BulkOpeningEditor
                ids={bulkLogistics.ids}
                onCancel={() => setBulkLogistics(null)}
                onDone={() => {
                    const current = bulkLogistics;
                    setBulkLogistics(null);
                    current.reset();
                }} />}
        </>
    )
}